'use client';

import { memo as Memo, useState, useCallback, useEffect } from 'react';
import { Text } from '@weareconceptstudio/core';

//* Styles
import OrientationPopupStyle from './style';

const OrientationPopup = Memo(() => {
	//! States
	const [landscape, setLandscape] = useState(false);

	useEffect(() => {
		checkOrientation();
	}, []);

	useEffect(() => {
		typeof window !== 'undefined' && window.addEventListener('resize', checkOrientation);

		return () => {
			window.removeEventListener('resize', checkOrientation);
		};
	}, [landscape]);

	const checkOrientation = useCallback(
		(e) => {
			setLandscape(window.innerWidth <= 896 && window.innerWidth >= window.innerHeight);
		},
		[landscape]
	);

	return landscape ? (
		<OrientationPopupStyle>
			<div className={'flex-center-block'}>
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='32'
					height='32'
					viewBox='0 0 32 32'
					fill='none'
				>
					<path
						d='M4.5 6C4.5 5.72386 4.72386 5.5 5 5.5C5.27614 5.5 5.5 5.72386 5.5 6V11.5H11C11.2761 11.5 11.5 11.7239 11.5 12C11.5 12.2761 11.2761 12.5 11 12.5H5C4.72386 12.5 4.5 12.2761 4.5 12V6Z'
						fill='var(--white1000)'
					/>
					<path
						d='M16.246 4.74336C19.0835 4.72685 21.8196 5.7601 23.9345 7.63203L24.3495 8.01777L24.414 8.09492C24.5446 8.28751 24.5263 8.55189 24.3573 8.7248C24.1643 8.92204 23.8477 8.92549 23.6503 8.73262C21.6736 6.80151 19.0153 5.72729 16.2519 5.74336C13.4884 5.75944 10.8427 6.86453 8.8886 8.81855L5.35344 12.3537C5.1582 12.5489 4.84165 12.5489 4.64641 12.3537C4.45117 12.1585 4.45122 11.8419 4.64641 11.6467L8.18156 8.11152C10.3218 5.97139 13.2194 4.76098 16.246 4.74336Z'
						fill='var(--white1000)'
					/>
					<path
						d='M26.5 26V20.5H21C20.7239 20.5 20.5 20.2761 20.5 20C20.5 19.7239 20.7239 19.5 21 19.5H27C27.2761 19.5 27.5 19.7239 27.5 20V26C27.5 26.2761 27.2761 26.5 27 26.5C26.7239 26.5 26.5 26.2761 26.5 26Z'
						fill='var(--white1000)'
					/>
					<path
						d='M26.6463 19.6464C26.8416 19.4512 27.1581 19.4512 27.3534 19.6464C27.5486 19.8417 27.5486 20.1582 27.3534 20.3535L23.8182 23.8886C21.678 26.0287 18.7804 27.2392 15.7538 27.2568C12.9163 27.2733 10.1802 26.24 8.06529 24.3681L7.65025 23.9824L7.5858 23.9052C7.45513 23.7126 7.47348 23.4483 7.64244 23.2754C7.81134 23.1027 8.07488 23.0781 8.27037 23.2041L8.34947 23.2675L8.7274 23.6191C10.6584 25.3285 13.157 26.2719 15.7479 26.2568C18.5113 26.2407 21.1571 25.1356 23.1112 23.1816L26.6463 19.6464Z'
						fill='var(--white1000)'
					/>
				</svg>

				<div className='text-block'>
					<Text className='p6 font-ogg-regular white-1000 align-center'>Rotate your</Text>

					<Text className='p6 font-ogg-regular white-1000 align-center'>phone please!</Text>
				</div>
			</div>
		</OrientationPopupStyle>
	) : null;
});

export default OrientationPopup;
